module.exports = __webpack_public_path__ + "assets/img/warrior-name-ff983049.png";